import { atom, createStore, getDefaultStore } from 'jotai';

let store = createStore();
const defaultStore = getDefaultStore();
const storeKey = atom(0);

const reset = () => {
  defaultStore.set(storeKey, (p) => p + 1);
  store = createStore();
};

export { store, storeKey, reset };
